.sections {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: var(--space-4);
}

.checkboxes {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin-top: var(--space-5);
  padding-top: var(--space-4);
  border-top: 1px solid var(--border);
}

.calloutSpacing {
  margin-top: var(--space-4);
}

/*
  The save bar sticks to the bottom of the viewport.

  This form is long enough to scroll past the button. An admin who changes a
  field near the top and cannot see how to save it will assume the change took
  effect on its own.
*/
.saveBar {
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-4);
  margin-top: var(--space-5);
  padding: var(--space-4) var(--space-5);
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}

.savedNote {
  margin-right: auto;
  font-size: var(--text-sm);
  color: var(--text-muted);
}

.muted { color: var(--text-muted); }
.error { color: var(--danger); }

/* ---------------------------------------------------------- operating days */

/*
  Two columns on a narrow screen, more when there is room. Seven checkboxes in
  one column is a long scroll for something read as a single week.
*/
.dayGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px 16px;
  margin: 12px 0;
}

/* The consequence note under the grid — quieter than body text. */
.hint {
  color: var(--text-muted);
  font-size: var(--text-sm);
  margin: 8px 0 0;
}

/* Affected sessions inside the confirmation dialog. */
.impactList {
  margin: 12px 0 0;
  padding-left: 20px;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.impactList li {
  margin-bottom: 4px;
}
